import { combineReducers } from 'redux';
import app from './app';
import main from './main';
import jobs from './jobs';

export default combineReducers({ app, main, jobs });
